import React from 'react';
import { splitDateTime } from '../lib/dateUtils';

interface TimestampCellProps {
  createdAt?: string | null;
  updatedAt?: string | null;
}

export const TimestampCell: React.FC<TimestampCellProps> = ({ createdAt, updatedAt }) => {
  const created = splitDateTime(createdAt);
  const updated = splitDateTime(updatedAt);
  const isEdited = Boolean(updated && created && updated.full !== created.full);

  if (!created) {
    return <span className="text-gray-400 text-xs">—</span>;
  }

  return (
    <div className="flex flex-col text-xs leading-tight whitespace-nowrap min-w-[5rem]">
      {/* Creation Date & Time (Multi-line) */}
      <span className="font-medium text-gray-800 text-[12px] block" title={`Created at: ${created.full}`}>
        {created.date}
      </span>
      {created.time && (
        <span className="text-[11px] text-gray-500 font-normal block tracking-tight" title={`Created at: ${created.full}`}>
          {created.time}
        </span>
      )}

      {/* Edit / Update indicator */}
      {isEdited && updated && (
        <div
          className="text-[10px] text-amber-700 bg-amber-50/90 border border-amber-200/70 rounded px-1 py-0.5 mt-1 inline-flex flex-col leading-tight max-w-fit"
          title={`Last updated at: ${updated.full}`}
        >
          <div className="inline-flex items-center gap-1 font-semibold">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-500 shrink-0"></span>
            <span>Upd: {updated.date}</span>
          </div>
          {updated.time && (
            <span className="text-[9.5px] text-amber-600/90 pl-2.5 font-normal">
              {updated.time}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

